import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import { Message } from 'primereact/message';
import { LoginService } from '../services/LoginService';
import { fetchCountryData, getSpecialityData, getState } from '../reduxactions/adminactions/AdminRegionActions';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Admin_API } from '../ApiNames';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
export const AdminRegions = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');

    const data = useSelector((state: RootState) => state.regions.get);

    const dispatch = useDispatch();


    const toast = useRef(data);

    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(getSpecialityData() as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const Close = () => {
        setaddDilog(false);

    }
    const [addDilog, setaddDilog] = useState(false);


    const [state, setState] = useState('');
    const [country, setCountry] = useState('');
    const [region, setRegion] = useState('');
    const countrydata = useSelector((state: RootState) => state.regions.country);
    const fetchCountryDatas = async () => {
        try {
            await dispatch(fetchCountryData() as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const statedata = useSelector((state: RootState) => state.regions.states);

    const getStateData = async (id: any) => {
        try {
            const state = id;
            await dispatch(getState(state) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffectOnce(() => {
        fetchDataAsync();
        fetchCountryDatas();
    }, [dispatch]);
    const addVolunteerDataAsync = async () => {
        if (!state || !country || !selectedDirections) {
            toast.current.show({ severity: 'error', detail: 'Please fill in all required fields.', life: 3000 });
            return;
        }
        const regionFlags = {
            eastregion: selectedDirections.includes("East"),
            westregion: selectedDirections.includes("West"),
            northregion: selectedDirections.includes("North"),
            southregion: selectedDirections.includes("South"),
        };
        try {
            const payload = { country: country, state: state, ...regionFlags, q: 1 };
            const apiname = Admin_API.regionsss_API;
            const response = await LoginService.getData(apiname, payload);
            fetchDataAsync();
            setState('');
            setCountry('');
            setSelectedDirections([]);
            setaddDilog(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const [editDilog, setEditDilog] = useState(false);

    const [editData, setEditData] = useState({
        country: '',
        state: '',
        region: [] as string[],
        id: '',
    });

    const ViewEditRowData = (rowData: any) => {

        setEditData({
            country: rowData.countryids,
            state: rowData.name,
            region: rowData.regionnames ? rowData.regionnames.split(',').map((r: string) => r.trim()) : [],
            id: rowData.id,
        });
        setEditDilog(true);
        getStateData(rowData.countryids);
    };
    const EditRegionFunction = async () => {
        const { country, state, region, id } = editData;
        const regionFlags1 = {
            eastregion: region.includes("East"),
            westregion: region.includes("West"),
            northregion: region.includes("North"),
            southregion: region.includes("South"),
        };
        try {
            const payload = { state: id, countryId: country, ...regionFlags1, q: 1 };
            const apiname = Admin_API.regionsss_API;
            const response = await LoginService.getData(apiname, payload);
            fetchDataAsync();
            setEditDilog(false);
            if (toast.current) {
                toast.current.show({ severity: 'success', detail: response });
            }
        } catch (error) {
            console.error('Error deleting data:', error);
        }
    };
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);

    const [removedata, setRemoveData] = useState({
        oid: '',
    });

    const Removeduring = (rowData: any) => {
        setRemoveData({
            oid: rowData.id,
        });
        setDeleteConfirmation(true);
    }

    const confirmDelete = async () => {
        const { oid } = removedata;
        const payload = { q: 3, rid: oid };
        const apiname = Admin_API.regionsss_API;
        const data = await LoginService.getData(apiname, payload);
        if (toast.current) {
            toast.current.show({ severity: 'success', detail: data });
        }
        setDeleteConfirmation(false);
        fetchDataAsync()
    };



    //checkbox 
    const [selectedDirections, setSelectedDirections] = useState<string[]>([]);

    const onDirectionChange = (e: any) => {
        let _selectedDirections = [...selectedDirections];

        if (e.checked)
            _selectedDirections.push(e.value);
        else
            _selectedDirections.splice(_selectedDirections.indexOf(e.value), 1);

        setSelectedDirections(_selectedDirections);
    };
    //edit 
    // const onDirectionEditChange = (e: any) => {
    //     const selected = editData.region;
    //     console.log('Entered IF',selected)

    //     if (e.checked) {
    //         selected.push(e.value);
    //     } else {
    //         console.log('Entered else')
    //         const index = selected.indexOf(e.value);
    //         if (index !== -1) selected.splice(index, 1);
    //     }

    //     setEditData({ ...editData, region: selected });
    // };
    const onDirectionEditChange = (e: any) => {
        let selected: string[] = [...editData.region];
        console.log(selected, 'select')

        if (e.checked) {
            if (!selected.includes(e.value)) {
                selected.push(e.value);
            }
        } else {
            selected = selected.filter(dir => dir !== e.value);
        }

        setEditData({ ...editData, region: selected });
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/adminregions.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };


    return (
        <div className="admin-layout-container">
            <div className="content-wrapper" style={{ marginLeft: '100px' }}>
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="grid mb-2">
                            <div className="col-6">
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content" style={{ marginLeft: '110px' }} >
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card-header p-2" style={{ marginTop: '50px' }}>
                                <h2>Regions List</h2>
                            </div>
                            <div className="col-16" style={{ textAlign: "right" }}>
                                <a
                                    title="help"
                                    onClick={(e) => openWindow(e, IUrl)}
                                    style={{

                                        color: "blue",
                                        fontSize: 15, cursor: "pointer"
                                    }}
                                >Help for this Page &nbsp;
                                    <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                </a>
                            </div>


                            <br></br>
                            <div className="card flex flex-wrap justify-content-end" style={{ marginRight: '30px' }}>
                                <Button label="Add Regions" severity="info" onClick={() => setaddDilog(true)} />
                            </div>
                            <div className="box box-primary">
                                <div className="card">
                                    <p className="m-0">
                                        <div>
                                            <div className="card flex flex-wrap justify-content">
                                                <span className="p-input-icon-left">
                                                    <i className="pi pi-search" style={{ paddingLeft: '5px' }} />
                                                    <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" style={{ paddingLeft: '25px' }} />
                                                </span>

                                            </div>
                                            <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                globalFilterFields={['regionnames', 'name', 'Phone', 'Status']}>
                                                <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                <Column field="regionnames" sortable header="Region Name"></Column>
                                                <Column field="name" sortable header="State"></Column>

                                                <Column header="Operation" body={(rowData) => (
                                                    <>

                                                        <Button className='mr-1' tooltip="Edit" severity="info" icon="pi pi-pencil" rounded outlined onClick={() => ViewEditRowData(rowData)} />
                                                        <Button className='mr-6' tooltip="Delete" severity="danger" icon="pi pi-trash" rounded outlined onClick={() => Removeduring(rowData)} />
                                                    </>
                                                )} />
                                            </DataTable>
                                        </div>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Dialog header="Add Regions" visible={addDilog} style={{ width: '34vw', height: 'auto' }} onHide={() => setaddDilog(false)} >
                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Country:</label>
                    </div>
                    <div className="col-6" >
                        <Dropdown
                            id="country"
                            value={country}
                            onChange={(e: DropdownChangeEvent) => { getStateData(e.value); setCountry(e.value); }}
                            options={countrydata}
                            optionLabel="name"
                            optionValue="countryids"
                            placeholder="Select a Country"
                            className="custom-dropdown-placeholder"
                            style={{ width: '18vw', marginLeft: '10px' }}
                        />

                    </div>
                </div>

                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">State :</label>
                    </div>
                    <div className="col-6" >
                        <Dropdown
                            id="state"
                            value={state}
                            onChange={(e: DropdownChangeEvent) => setState(e.value)}
                            options={statedata}
                            optionLabel="name"
                            optionValue="name"
                            placeholder="Select a State"
                            className="custom-dropdown-placeholder"
                            style={{ width: '18vw', marginLeft: '10px' }}
                        />
                    </div>
                </div>
                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Regions:</label>
                    </div>
                    <div className="card flex flex-wrap justify-content-center gap-3" style={{ marginBottom: '20px', marginTop: '15px' }}>
                        <div className="flex align-items-center">
                            <Checkbox inputId="direction1" name="direction" value="East" onChange={onDirectionChange} checked={selectedDirections.includes('East')} />
                            <label htmlFor="direction1" className="ml-2">East</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="direction2" name="direction" value="West" onChange={onDirectionChange} checked={selectedDirections.includes('West')} />
                            <label htmlFor="direction2" className="ml-2">West</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="direction3" name="direction" value="North" onChange={onDirectionChange} checked={selectedDirections.includes('North')} />
                            <label htmlFor="direction3" className="ml-2">North</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="direction4" name="direction" value="South" onChange={onDirectionChange} checked={selectedDirections.includes('South')} />
                            <label htmlFor="direction4" className="ml-2">South</label>
                        </div>
                    </div>
                </div>


                <Button label="Close" onClick={Close} severity="secondary" />
                <Button label="Add" onClick={addVolunteerDataAsync} style={{ float: 'right' }} />
            </Dialog >
            <Dialog header="Edit Regions" visible={editDilog} style={{ width: '34vw', height: 'auto' }} onHide={() => setEditDilog(false)} >
                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Country:</label>
                    </div>
                    <div className="col-6" >
                        <Dropdown
                            id="country"
                            value={editData.country}
                            onChange={(e: DropdownChangeEvent) => { getStateData(e.value); setEditData({ ...editData, country: e.target.value }) }}
                            options={countrydata}
                            optionLabel="name"
                            optionValue="countryids"
                            placeholder="Select a Country"
                            className="custom-dropdown-placeholder"
                            style={{ width: '18vw', marginLeft: '10px' }}
                        />

                    </div>
                </div>

                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">State :</label>
                    </div>
                    <div className="col-6" >
                        <Dropdown
                            id="state"
                            value={editData.state}
                            onChange={(e: DropdownChangeEvent) => setEditData({ ...editData, state: e.target.value })}
                            options={statedata}
                            optionLabel="name"
                            optionValue="name"
                            placeholder="Select a State"
                            className="custom-dropdown-placeholder"
                            style={{ width: '18vw', marginLeft: '10px' }}
                        />
                    </div>
                </div>
                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Regions:</label>
                    </div>
                    <div className="card flex flex-wrap justify-content-center gap-3" style={{ marginBottom: '20px', marginTop: '15px' }}>
                        <div className="flex align-items-center">
                            <Checkbox inputId="direction1" name="direction" value="East"
                                onChange={onDirectionEditChange}
                                checked={editData.region.includes('East')} />
                            <label htmlFor="direction1" className="ml-2">East</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="direction2" name="direction" value="West"
                                onChange={onDirectionEditChange}
                                checked={editData.region.includes('West')} />
                            <label htmlFor="direction2" className="ml-2">West</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="direction3" name="direction" value="North"
                                onChange={onDirectionEditChange}
                                checked={editData.region.includes('North')} />
                            <label htmlFor="direction3" className="ml-2">North</label>
                        </div>
                        <div className="flex align-items-center">
                            <Checkbox inputId="direction4" name="direction" value="South"
                                onChange={onDirectionEditChange}
                                checked={editData.region.includes('South')} />
                            <label htmlFor="direction4" className="ml-2">South</label>
                        </div>
                    </div>
                </div>
                <Button label="Close" onClick={Close} severity="secondary" />
                <Button label="Update" onClick={EditRegionFunction} style={{ float: 'right' }} />
            </Dialog >

            < Dialog header="Conform Delete " style={{ width: '30vw' }} visible={deleteConfirmation} onHide={() => setDeleteConfirmation(false)}>
                <div>Are you really want to Remove...?</div>
                <br></br>
                <Button label="Close" onClick={Close} className="mr-3 p-button-secondary" />
                <Button label="Delete" className='mr-3 p-button-raised' onClick={confirmDelete} />
            </Dialog >

            <Toast ref={toast} ></Toast>
        </div>
    )
}
